import type { Material, Mesh, Object3D } from "three"
import isMesh from "./isMesh"

export default function getSceneWindows (root: Object3D) {
  const list : Array<Mesh> = []
  root.traverse((obj) => {
    if (isMesh(obj)) {
      // console.log(obj.name, (obj.material as Material).name)
      if ((obj.material as Material).name === 'Window') {
        list.push(obj)
      }
    }
  })
  return list
}

